module.exports = __webpack_public_path__ + "img/paypal-dent-red.23411044.svg";